/* eslint-disable eqeqeq */
import { Field, Formik } from "formik";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  DatePicker,
  FieldDropSide,
  SearchableList,
  CsplTable as Table,
} from "../../../components";
import { usDateFormat } from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { getEmployeeRehireDetails } from "../../../services";
import { useRouterParams, useRequest } from "../../../abstracts";
import { getEmploymentStatusList } from "../../../services";
import { isDate } from "moment";
import moment from "moment";

const columns = [
  {
    label: "Hire / rehire date",
    className: "column-rehireDate",
    columnName: "rehireDate",
  },
  {
    label: "Term date",
    className: "column-termDate",
    columnName: "terminationDate",
  },
];

const WithdrawalRequestEmploymentAgeDetail = (props) => {
  const [isAdd, setIsAdd] = useState(false);
  const toggle = () => {
    setIsAdd(!isAdd);
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const { fields, filteredValues, isEdit, isSave } = props;
  const { censusId } = useRouterParams();
  //const intcensusId = parseInt(censusId, 10);

  //   const onDaySelected = (fieldName, value) => {
  //     setFieldValue(fieldName, new Date(value));
  //   };

  //   const calculateAge = (birthDate) => {
  //     var a = moment();
  //     var b = moment(new Date(birthDate), "MM-YYYY");
  //     var age = moment.duration(a.diff(b));
  //     return age.years() <= 1 && age.months() <= 1
  //       ? age.years() + " year " + age.months() + " month"
  //       : age.years() <= 1
  //       ? age.years() + " year " + age.months() + " months"
  //       : age.months() <= 1
  //       ? age.years() + " years " + age.months() + " month"
  //       : age.years() + " years " + age.months() + " months";
  //   };

  // const { loading: IsLoading, response: rehireDetails } = useRequest({
  //   method: getEmployeeRehireDetails,
  //   payload: censusId,
  //   defaultResponse: [],
  // });

  //   const rehireDetails = get(values, "rehireDetails", []);

  //   const { response: employmentStatusList } = useRequest({
  //     method: getEmploymentStatusList,
  //     payload: get(values, "companyId", 0),
  //     defaultResponse: [],
  //   });

  //   const masterEmploymentStatusId = employmentStatusList.find(
  //     ({ id }) => id === values[fields.employmentStatusId]
  //   )
  //     ? employmentStatusList.find(
  //         ({ id }) => id === values[fields.employmentStatusId]
  //       ).employmentStatus
  //     : 0;

  return (
    <Formik>
      <div>
        <p className="mt-20 plan-sub-heading">Dates</p>
        <div className="d-flex">
          <Field
            isRequired
            label="Date of Birth"
            size="md"
            name={fields.birthDate}
            value={usDateFormat(filteredValues.birthDate)}
            //   isDatePicker
            //   onClear={() => onDaySelected(fields.birthDate, null)}
            //   popupContent={
            //     <DatePicker
            //       onDayClick={(value) => onDaySelected(fields.birthDate, value)}
            //       value={usDateFormat(values[fields.birthDate])}
            //     />
            //   }
            component={FieldDropSide}
            disabled={true}
          />
          {/* {values.birthDate === undefined ||
        values.birthDate === null ||
        values.birthDate > new Date() ? (
          ""
        ) : (
          <div
            className="plan-sub-heading mt-20 ml-4"
            style={{ alignSelf: "flex-end" }}
          >
            {calculateAge(values.birthDate)}
          </div>
        )} */}
        </div>
        <Field
          isRequired
          label="Hire Date"
          size="md"
          name={fields.hireDate}
          value={usDateFormat(filteredValues.hireDate)}
          // isDatePicker
          // onClear={() => onDaySelected(fields.hireDate, null)}
          // popupContent={
          //   <DatePicker
          //     onDayClick={(value) => onDaySelected(fields.hireDate, value)}
          //     value={usDateFormat(values[fields.hireDate])}
          //   />
          // }
          component={FieldDropSide}
          disabled={true}
        />
        <Field
          size="md"
          isRequired
          name={fields.employmentStatus}
          value={filteredValues.employmentStatus}
          // options={
          //   employmentStatusList &&
          //   employmentStatusList.map((status, index) => ({
          //     label: status.employmentStatusName,
          //     value: status.id,
          //   }))
          // }
          label="Employment Status"
          // popupContent={
          //   <SearchableList
          //     label="Select Employment Status"
          //     options={
          //       employmentStatusList &&
          //       employmentStatusList.map((status, index) => ({
          //         label: status.employmentStatusName,
          //         value: status.id,
          //       }))
          //     }
          //     onSelect={(value) => {
          //       setFieldValue(
          //         fields.employmentStatus,
          //         employmentStatusList.find((x) => x.id === value)
          //           .employmentStatusName
          //       );
          //       setFieldValue(fields.employmentStatusId, value);
          //       let _ = employmentStatusList.find(({ id }) => id === value);
          //       if (!isStartDate && ![4, 5, 9].includes(_.employmentStatus)) {
          //         setFieldValue(fields.leaveStartDate, null);
          //       }
          //       if (!isEndDate && ![4, 5, 9].includes(_.employmentStatus)) {
          //         setFieldValue(fields.leaveEndDate, null);
          //       }
          //     }}
          //     selectedValue={values[fields.employmentStatusId]}
          //     value={values[fields.employmentStatusId]}
          //   />
          // }
          component={FieldDropSide}
          disabled={true}
        />

        <Field
          label="Leave Start Date"
          isRequired
          size="md"
          name={fields.leaveStartDate}
          value={usDateFormat(filteredValues.leaveStartDate)}
          // isDatePicker
          // onClear={() => onDaySelected(fields.leaveStartDate, null)}
          // popupContent={
          //   <DatePicker
          //     onDayClick={(value) => onDaySelected(fields.leaveStartDate, value)}
          //     value={usDateFormat(values[fields.leaveStartDate])}
          //   />
          // }
          component={FieldDropSide}
          disabled={true}
        />
        <Field
          label="Leave End Date"
          size="md"
          name={fields.leaveEndDate}
          value={usDateFormat(filteredValues.leaveEndDate)}
          // isDatePicker
          // onClear={() => onDaySelected(fields.leaveEndDate, null)}
          // popupContent={
          //   <DatePicker
          //     onDayClick={(value) => onDaySelected(fields.leaveEndDate, value)}
          //     value={usDateFormat(values[fields.leaveEndDate])}
          //   />
          // }
          component={FieldDropSide}
          disabled={true}
        />

        <Field
          label="Most Recent Term Date"
          isRequired
          size="md"
          name={fields.terminationDate}
          value={usDateFormat(filteredValues.terminationDate)}
          // isDatePicker
          // onClear={() => onDaySelected(fields.terminationDate, null)}
          // popupContent={
          //   <DatePicker
          //     onDayClick={(value) => onDaySelected(fields.terminationDate, value)}
          //     value={usDateFormat(values[fields.terminationDate])}
          //   />
          // }
          component={FieldDropSide}
          disabled={true}
        />
        <Field
          label="Most Recent Rehire Date"
          isRequired
          size="md"
          name={fields.rehireDate}
          value={usDateFormat(filteredValues.rehireDate)}
          // isDatePicker
          // onClear={() => onDaySelected(fields.rehireDate, null)}
          // popupContent={
          //   <DatePicker
          //     onDayClick={(value) => onDaySelected(fields.rehireDate, value)}
          //     value={usDateFormat(values[fields.rehireDate])}
          //   />
          // }
          component={FieldDropSide}
          disabled={true}
        />
        {/* {isEdit == true || censusId != undefined ? (
        <p className="link-text font-weight-500" onClick={toggle}>
          {isAdd === false ? "View Rehire Details" : "Hide Rehire Details"}
        </p>
      ) : null}
      {isAdd === true ? (
        <RehireDetails
          isEdit={isEdit}
          isSave={isSave}
          rehireDetails={rehireDetails}
        />
      ) : null} */}
        <Modal show={show} onHide={handleClose}>
          <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
            <div className="text-right">
              <FontAwesomeIcon
                icon={faTimes}
                color="#000"
                onClick={handleClose}
              />
            </div>
            <div className="d-flex">
              <div className="pd-15">
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  color="#f94f50"
                  size="3x"
                />
              </div>
              <div className="remove-text">
                <h4>Are you sure?</h4>
                <p>You want to remove the Rehire details.</p>
                <Button className="remove-btn mr-4" onClick={handleClose}>
                  REMOVE
                </Button>
                <Button className="cancel-btn" onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </Formik>
  );
};

export default WithdrawalRequestEmploymentAgeDetail;
